import {phaseTypes} from '@swiss-ski/sski-entity-types';

export const SUBTOPICS_ID = ['introduction-home', 'introduction-what', 'introduction-howmuch', 'introduction-environment'];

export const CATEGORY_ID = 'id';

export const FIXED_CATEGORY = 'sponsorship';

export const phaseNamesMapper = {
    E: phaseTypes.ELITE,
    F: phaseTypes.FOUNDATION,
    M: phaseTypes.MASTERY,
    T: phaseTypes.TALENT,
};

export const EMPTY_ELEMENT = 'empty';

export const CLEAR_SEARCH = 'clear_search';

export const NOTIFICATION_TIMER = 3000;

export const NEWS_TIMER = 3000;

export const ERROR = 'error';

export const DEFAULT_CATS_URL = '?id=age-category&id=developmentfocus&id=training-principles&id=endurance&id=power';

export const LANGUAGES = [{label: 'French', value: 'fr'},
    {label: 'Italian', value: 'it'},
    {label: 'Romansh', value: 'rm'},
    {label: 'German', value: 'de'},
    {label: 'English', value: 'en'}];
